import { useState, useEffect } from 'react';
import { Form } from 'antd';
import Moment from 'moment';
import API from '../../../../../services/API';


export default function useStatementPatchForm({
  statements,
}) {
  const [statementsForm] = Form.useForm();
  const [furnishingStatements, setFurnishingStatements] = useState([]);
  const [statementsToBePatched, setStatementsToBePatched] = useState([]);
  const [newStatements, setNewStatements] = useState([]);
  const [patchStatus, setPatchStatus] = useState({});

  const statementsFormReset = () => {
    const statementsToPatch = statements.map((statement) => ({
      original: {
        ...statement
      },
      ...statement,
      lastPaymentDate: statement?.lastPaymentDate ? Moment(statement.lastPaymentDate) : null,
      doPatch: false,
      newStatement: false
    }));

    setFurnishingStatements(statementsToPatch);

    statementsForm.setFieldsValue({ statements: statementsToPatch });
  };

  useEffect(() => {
    statementsFormReset();
  }, [statements, statementsForm]);
  
  const statementFilter = (statement) => {
    return statement?.doPatch
      && (
        statement.lastPaymentDate?.format("YYYY-MM-DD") !== statement.original.lastPaymentDate
        || `${statement.actualMonthlyPayment}` !== `${statement.original.actualMonthlyPayment}`
        || `${statement.currentBalance}` !== `${statement.original.currentBalance}`
        || `${statement.amountPastDue}` !== `${statement.original.amountPastDue}`
        || `${statement.daysDelinquent}` !== `${statement.original.daysDelinquent}`
        || `${statement.scheduledMonthlyPayment}` !== `${statement.original.scheduledMonthlyPayment}`
      );
  }

  const patchSubmit = (data) => {
    const filteredStatements = data?.statements?.filter(statementFilter) || [];
    const filteredNewStatements = data?.statements?.filter((statement => statement.newStatement)) || [];
    const patchStatuses = {};
    filteredStatements.forEach((statement) => patchStatuses[statement.statementId] = { status: false, patching: false, errorMsg: false } );
    setStatementsToBePatched(filteredStatements);
    setPatchStatus(patchStatuses);
    setNewStatements(filteredNewStatements);
    console.log('filteredStatements', filteredStatements, 'filteredNewStatements', filteredNewStatements);
  }

  const patchStatement = (data) => {
    const { statementId } = data;
    setPatchStatus((prev) => ({
      ...prev,
      [statementId]: { status: false, patching: true, errorMsg: false },
    }));

    const updatedData = {
      ...data,
      lastPaymentDate: data?.lastPaymentDate ? data.lastPaymentDate.format('YYYY-MM-DD') : null
    }

    return API.patchBloomStatement(statementId, updatedData)
      .then(() => {
        setPatchStatus((prev) => ({
          ...prev,
          [statementId]: { status: true, patching: false, errorMsg: false },
        }));
      }).catch((error) => {
        setPatchStatus((prev) => ({
          ...prev,
          [statementId]: { status: false, patching: false, errorMsg: error?.message },
        }));
      });
  }

  return {
    statementsForm,
    furnishingStatements,
    patchSubmit,
    statementsToBePatched,
    newStatements,
    patchStatus,
    patchStatement,
    statementsFormReset
  }
}